import { inject } from '@angular/core';
import { PublicRoutes, StationDurations } from '../../../enums';
import { StationsService } from '../../../services';

export class NgxAimStationSelectDuration {
  stationsService = inject(StationsService);

  routes = PublicRoutes;
  durations = StationDurations;
  selectedDuration = this.stationsService.getSelectedDuration();

  onDurationClick(durationMinutes: number) {
    if (durationMinutes) {
      this.selectedDuration = durationMinutes;
      this.stationsService.setSelectedDuration(durationMinutes);
    }
  }
}